import {requestHelpers} from '../../../../../helpers';
import {updateTodoList} from '../../../../../actions/todo_list/todo_list';

export const actions = {
  SET_EXPERIENCE: "SET_EXPERIENCE",
  GENERAL_EXPERIENCE_REQUEST: "GENERAL_EXPERIENCE_REQUEST",
  GENERAL_EXPERIENCE_SUCCESS: "GENERAL_EXPERIENCE_SUCCESS",
  GENERAL_EXPERIENCE_ERROR: "GENERAL_EXPERIENCE_ERROR",
  DELETE_EXPERIENCE_SUCCESS: "DELETE_EXPERIENCE_SUCCESS"
};

export const setExperience = (profile) => {
  const experienceWithPersonId = profile.experience.map(e => Object.assign(e, {person_id: profile.id}));
  const noData = experienceWithPersonId.length === 0;
  return {
    type: actions.SET_EXPERIENCE,
    personId: profile.id,
    body: experienceWithPersonId,
    noData
  }
};

export const experienceApiCall = (personId, payload, type, callback) => {

  const requestType = type === 'CREATE' ? 'POST' : ( type === 'UPDATE' ? 'PUT' : "DELETE" );
  const endpoint = type === 'CREATE' ? '' : ( payload.id ? `/${ payload.id }` : `/${ payload }`);

  const _payload = {...payload};
  if (requestType !== 'DELETE') {
    const endDate = payload.i_still_work_here ? undefined : ( payload.end_year.value && payload.end_month.value ? `${ payload.end_year.value }-0${ payload.end_month.value }` : "");
    const noEndDateDBFix = ( type === 'CREATE' ? undefined : '' );

    _payload.start_date = `${ payload.start_year.value }-0${ payload.start_month.value }`;
    _payload.end_date = ( endDate === "undefined-0undefined" || !endDate ) ? noEndDateDBFix : endDate;

    ['expertise_id', 'industry_id', 'sector_id', 'market_id', 'start_month', 'start_year', 'end_month', 'end_year']
      .forEach(item => delete payload[item]);
  }

  return (dispatch) => {
    dispatch({
      type: actions.GENERAL_EXPERIENCE_REQUEST,
      isExperienceFetching: true,
      isExperienceError: false
    });

    requestHelpers
      .authenticatedPostRequest(`/profiles/${ personId }/experience${endpoint}`, _payload, requestType)
      .then((response) => {
        callback();
        payload.hasOwnProperty('id') ? _payload.id = _payload.id || response.data.id : payload;
        dispatch({
          type: requestType === 'DELETE' ? actions.DELETE_EXPERIENCE_SUCCESS : actions.GENERAL_EXPERIENCE_SUCCESS,
          personId,
          body: requestType === 'DELETE' ? payload : _payload,
          // dataWithNames,
          isExperienceFetching: false,
          isExperienceError: false
        });
      }).catch((error) => {
        return callback(error)
      });
      dispatch(updateTodoList(personId, 8));
  }
};






// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/experience.js